import { useEffect, useState } from 'react'
import type { IntelligenceResponse } from '../types/global'

export function useIntelligence(enabled = true, dateKey?: string) {
  const [data, setData] = useState<IntelligenceResponse | null>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    if (!enabled) return
    const controller = new AbortController()
    const baseUrl = import.meta.env.VITE_INTELLIGENCE_API_URL || '/api/intelligence'
    const url = dateKey ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}date=${encodeURIComponent(dateKey)}` : baseUrl
    fetch(url, { signal: controller.signal })
      .then(async (response) => { if (!response.ok) throw new Error('Intelligence unavailable'); return response.json() as Promise<IntelligenceResponse> })
      .then(setData)
      .catch((cause: unknown) => { if ((cause as Error).name !== 'AbortError') setError('DAILY BRIEF TEMPORARILY UNAVAILABLE') })
    return () => controller.abort()
  }, [enabled, dateKey])
  return { data, error, loading: enabled && !data && !error }
}
